/*
 * IMPORTS
*/

import React from 'react';
import { Box, Stack, Text, useStyleConfig } from '@chakra-ui/react';
import DbServerInfo from 'components/DbServerInfo';
import NodeServerInfo from 'components/NodeServerInfo';

const SystemInfoStats = () => {
  const styles = useStyleConfig('Card');

  return (
    <Box __css={styles} bg="white" w="100%" p={1} borderRadius="16px" fontFamily="DM Sans">
      <Text fontSize="20px" fontWeight="800" color="gray.800" mb={4} pl={2} mt={2}>
        System Information
      </Text>

      <Stack spacing={2}>
        <NodeServerInfo />
        <DbServerInfo />
      </Stack>
    </Box>
  );
};

export default SystemInfoStats;
